import {
    AfterViewInit,
    Directive,
    ElementRef,
    Input,
    Renderer2,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import {TranslatedString, translateString} from "./translation-helper";

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@Directive({
    selector: '[libAutoWidth]'
})
export class AutoWidthDirective implements AfterViewInit, OnChanges {
    @Input('libAutoWidth') items: any[] = [];
    @Input() bindLabel = ''; // e.g. 'description'
    @Input() translatedLabel = ''; // e.g. 'translatedDescription'
    @Input() hasIcon = false;

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngAfterViewInit() {
        this.updateWidth();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['items']) {
            this.updateWidth();
        }
    }

    updateWidth() {
        if (!this.items || !Array.isArray(this.items)) return;

        const container = this.el.nativeElement as HTMLElement;

        const testSpan = this.renderer.createElement('span');
        this.renderer.setStyle(testSpan, 'position', 'absolute');
        this.renderer.setStyle(testSpan, 'visibility', 'hidden');
        this.renderer.setStyle(testSpan, 'white-space', 'nowrap');
        this.renderer.setStyle(testSpan, 'font-size', getComputedStyle(container).fontSize);
        this.renderer.setStyle(testSpan, 'font-family', getComputedStyle(container).fontFamily);
        this.renderer.appendChild(document.body, testSpan);

        let maxWidth = 0;

        for (const item of this.items) {
            let label: string | undefined;

            if (this.translatedLabel && item[this.translatedLabel]) {
                label = translateString(item[this.translatedLabel] as TranslatedString);
            } else if (this.bindLabel && item[this.bindLabel]) {
                label = item[this.bindLabel]?.toString();
            } else {
                label = item?.toString();
            }

            testSpan.textContent = label ?? '';
            const width = testSpan.getBoundingClientRect().width;
            const iconOffset = this.hasIcon ? 28 : 0;
            maxWidth = Math.max(maxWidth, width + iconOffset);
        }

        this.renderer.removeChild(document.body, testSpan);

        const finalWidth = Math.ceil(maxWidth + 32); // Add buffer for padding, dropdown arrows, etc.
        this.renderer.setStyle(container, 'width', `${finalWidth}px`);
    }
}

@NgModule({
    declarations: [AutoWidthDirective],
    imports: [CommonModule],
    exports: [AutoWidthDirective]
})
export class AutoWidthModule {}